import Immutable from 'immutable';
import range from 'lodash/range';
import { hasLinksInBlock } from 'wix-rich-content-common';
import Hashtag from './HashtagComponent';
import hashtagRegexes from './hashtagRegexes';
var HashtagDecorator = /** @class */ (function () {
    function HashtagDecorator(componentProps) {
        this.componentProps = componentProps;
    }
    HashtagDecorator.prototype.getDecorations = function (block, contentState) {
        var key = block.getKey();
        var text = block.getText();
        var type = block.getType();
        var decorations = Array(text.length).fill(null);
        if (type === 'code-block' ||
            !text ||
            hasLinksInBlock(block, contentState) ||
            !text.match(hashtagRegexes.hashSigns)) {
            return Immutable.List(decorations); // eslint-disable-line new-cap
        }
        text.replace(hashtagRegexes.validHashtag, function (match, before, hash, hashText, offset, chunk) {
            var after = chunk.slice(offset + match.length);
            if (after.match(hashtagRegexes.endHashtagMatch)) {
                return;
            }
            var start = offset + before.length;
            var end = start + hashText.length + 1;
            var htagId = "htag" + start + end;
            var tagRange = range(start, end, 1);
            tagRange.forEach(function (i) { return (decorations[i] = key + "-" + htagId); });
        });
        return Immutable.List(decorations); // eslint-disable-line new-cap
    };
    HashtagDecorator.prototype.getComponentForKey = function () {
        return Hashtag;
    };
    HashtagDecorator.prototype.getPropsForKey = function () {
        return this.componentProps;
    };
    return HashtagDecorator;
}());
export default HashtagDecorator;
//# sourceMappingURL=HashtagDecorator.js.map